<template>
  <div class="patient-detail">
    <!-- <div class="split-line"></div> -->
    <el-row>
      <el-col :span="8">
        <label>病人姓名：</label>
        <span>{{ prescriptionDetail.name }}</span>
      </el-col>
      <el-col :span="8">
        <label>性别：</label>
        <span>{{ prescriptionDetail.gender | Sex }}</span>
      </el-col>
      <el-col :span="8">
        <label>年龄：</label>
        <span>{{ prescriptionDetail.age }}</span>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <label>手机：</label>
        <span>{{ patientMobile || prescriptionDetail.patientMobile }}</span>
        <i v-if="!patientMobile" class="el-icon-view" @click="getPatientMobile"></i>
      </el-col>
      <el-col :span="8">
        <label>{{ prescriptionDetail.prescriptionType === 0 ? '主诉' : '证型' }}：</label>
        <span>
          {{
            prescriptionDetail.prescriptionType === 0
              ? prescriptionDetail.diseasesDetailDesc
              : prescriptionDetail.diseasesName
          }}
        </span>
      </el-col>
      <el-col :span="8">
        <label>{{ prescriptionDetail.prescriptionType === 0 ? '诊断' : '病名' }}：</label>
        <span>
          {{
            prescriptionDetail.prescriptionType === 0
              ? prescriptionDetail.diseasesName
              : prescriptionDetail.diseasesDetailDesc
          }}
        </span>
      </el-col>
    </el-row>

    <el-row v-if="prescriptionDetail.prescriptionType === 0">
      <el-col :span="8">
        <label>过敏史：</label>
        <span>{{ prescriptionDetail.allergy || '无' }}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Sex } from '@/filter';

export default {
  name: 'patientDetail',
  props: {
    prescriptionDetail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      patientMobile: ''
    };
  },
  methods: {
    getPatientMobile() {
      const { id } = this.prescriptionDetail;
      return Fetch.queryPatientInfoByPrescriptionId(id).then(({ mobile }) => {
        this.patientMobile = mobile;
      });
    }
  },
  filters: {
    Sex
  }
};
</script>

<style lang="scss">
.patient-detail {
  padding-top: 24px;

  .el-icon-view {
    margin-left: 10px;
  }
}
</style>
